module.exports = __webpack_public_path__ + "img/paper.bcb11580.svg";